import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-head-carousel',
  templateUrl: './head-carousel.component.html',
  styleUrls: ['./head-carousel.component.css']
})
export class HeadCarouselComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
